package com.qrkontaq.ui.components.buttons

import androidx.compose.runtime.Composable
import com.qrkontaq.ui.theme.AppColors
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

@Composable
fun PrimaryButton(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    size: ButtonSize = ButtonSize.LG,
    fullWidth: Boolean = false
) {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Button(
        onClick = { onClick() },
        size = size,
        enabled = enabled,
        modifier = modifier
            .then(if (fullWidth) Modifier.fillMaxWidth() else Modifier)
            .backgroundColor(AppColors.Primary)
            .color(colors.onPrimary)
            .padding(leftRight = 24.px, topBottom = 12.px)
            .borderRadius(8.px)
            .cursor(if (enabled) Cursor.Pointer else Cursor.NotAllowed)
            .opacity(if (enabled) 1.0 else 0.6)
    ) {
        SpanText(text)
    }
}

@Composable
fun SecondaryButton(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    size: ButtonSize = ButtonSize.LG,
    fullWidth: Boolean = false
) {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Button(
        onClick = { onClick() },
        size = size,
        enabled = enabled,
        modifier = modifier
            .then(if (fullWidth) Modifier.fillMaxWidth() else Modifier)
            .backgroundColor(colors.surface)
            .color(colors.textPrimary)
            .border(1.px, LineStyle.Solid, colors.border)
            .padding(leftRight = 24.px, topBottom = 12.px)
            .borderRadius(8.px)
            .cursor(if (enabled) Cursor.Pointer else Cursor.NotAllowed)
            .opacity(if (enabled) 1.0 else 0.6)
    ) {
        SpanText(text)
    }
}

@Composable
fun TextButton(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    size: ButtonSize = ButtonSize.LG
) {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Button(
        onClick = { onClick() },
        size = size,
        enabled = enabled,
        modifier = modifier
            .backgroundColor(org.jetbrains.compose.web.css.Color("transparent"))
            .color(AppColors.Primary)
            .padding(leftRight = 16.px, topBottom = 8.px)
            .cursor(if (enabled) Cursor.Pointer else Cursor.NotAllowed)
            .opacity(if (enabled) 1.0 else 0.6)
    ) {
        SpanText(text)
    }
}
